import { captureSlidePreview } from "../../../../helpers/captureSlidePreview";

export const updatePreview = async (props, id, textArea = false) => {
	let preview = await captureSlidePreview(id, textArea);
	return new Promise((resolve, reject) => {
		if (!preview) return resolve(false);
		let slides = [...props.slideList.slides];
		for (let i = 0; i < slides.length; i++) {
			if (slides[i].id === id) {
				slides[i] = {
					...slides[i],
					preview,
				};
				break;
			}
		}
		props.updateSlides({ slides });
		return resolve(preview);
	});
};
